import React from 'react'
// libs
import styled from 'styled-components'
import { Helmet } from 'react-helmet-async'
import { useMutation } from '@apollo/client/react'
// components
import { Tab } from '@mui/material'
import { Tabs as TabsOrigin } from 'components/UI'
import BusinessUnitsTree from 'components/PageComponents/Settings/BusinessUnits/components/Tree/index'
import NavigationSidebar from 'components/UI/NavigationSidebar'
import MainLayoutContainer from 'containers/MainLayout/index'
import BusinessEntityModal from 'components/Modals/BusinessEntityModal'
import BusinessUnitsHierarchyTree from 'components/PageComponents/Settings/BusinessUnits/components/Hierarchy'
import { CreateBusinessUnitButton, ImportCsvButton } from 'components/CTAs'
import { LayoutContainerInnerWrapper } from 'themes/views/layouts'
// graphql
import { BUSINESS_UNITS_SELECT_QUERY } from 'graphql/businessUnit/queries'
import {
  BUSINESS_UNIT_CREATE_MUTATION,
  BUSINESS_UNIT_UPDATE_MUTATION,
  BUSINESS_UNITS_BULK_IMPORT_MUTATION
} from 'graphql/businessUnit/mutations'
// context
import { BusinessUnitsAPIContext } from 'containers/BusinessUnits/layers/API'
// constants
import { ENTITIES } from 'constants/entities'
// utils
import { businessUnitProps } from 'components/FormElements/ReduxForm/ReduxEntitySelect/utils'
import { settingsSidebarConfig } from 'layouts/SettingsLayout/config'

const Tabs = styled((props) => <TabsOrigin {...props} />)`
  margin-right: 16px;
`

const Content = styled.div`
  height: calc(100% - 50px);
`

const BusinessUnits: React.FC = () => {
  const [createMutation] = useMutation(BUSINESS_UNIT_CREATE_MUTATION)
  const [updateMutation] = useMutation(BUSINESS_UNIT_UPDATE_MUTATION)
  const [bulkImportMutation] = useMutation(BUSINESS_UNITS_BULK_IMPORT_MUTATION)

  const { refetch, lastPosition, isLoading } = React.useContext(BusinessUnitsAPIContext)

  const [tab, setTab] = React.useState(0)

  const handleSetTab = (_, value) => setTab(value)

  return (
    <>
      <Helmet>
        <title>Skefto - Business Units</title>
      </Helmet>
      <MainLayoutContainer
        isLoading={isLoading}
        CTA={
          tab === 0 ? (
            <>
              <CreateBusinessUnitButton />
              <ImportCsvButton mutation={bulkImportMutation} onImported={refetch} />
            </>
          ) : null
        }>
        <NavigationSidebar config={settingsSidebarConfig} />
        <LayoutContainerInnerWrapper>
          <Tabs value={tab} onChange={handleSetTab} indicatorColor='primary' textColor='primary' variant={null}>
            <Tab label='View' />
            <Tab label='Hierarchy' />
          </Tabs>

          <Content>
            {tab === 0 && <BusinessUnitsTree />}
            {tab === 1 && <BusinessUnitsHierarchyTree />}
          </Content>
        </LayoutContainerInnerWrapper>
      </MainLayoutContainer>

      <BusinessEntityModal
        {...businessUnitProps}
        refetch={refetch}
        lastPosition={lastPosition}
        createMutation={createMutation}
        updateMutation={updateMutation}
        entityType={ENTITIES.BUSINESS_UNIT}
        query={BUSINESS_UNITS_SELECT_QUERY}
      />
    </>
  )
}

export default BusinessUnits
